export const initial_state = {
    agencies: {
        lists: [],
        total: 0,
        hasMore: false,
        page: 1,
    },
    realtors: {
        lists: [],
        total: 0,
        hasMore: false,
        page: 1,
    },
    page_type: '',
    city_id: '',
    district_id: '',
    skeleton: false
}

export const reducer = (state, action) => {
    switch (action.type) {
        case 'ADD_AGENCIES':
            return {
                ...state,
                agencies: action.payload.agencies,
                page_type: action.payload.page_type,
                city_id: action.payload.city_id,
                district_id: action.payload.district_id,
                skeleton: false,
            }
        case 'ADD_REALTORS':
            return {
                ...state,
                realtors: action.payload.realtors,
                page_type: action.payload.page_type,
                city_id: action.payload.city_id,
                district_id: action.payload.district_id,
                skeleton: false,
            }
        case 'SET_SKELETON':
            return {
                ...state,
                skeleton: action.payload.skeleton,
            }
    }
}